export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];
